export const GetGeneralDataString = () => {
    return "https://liquibot-api.herokuapp.com/get_data";
}